// MapLibre приходит отдельным модулем (app/assets/javascripts/maps.js) и может
// загрузиться позже, чем подключится контроллер карты.
export function mapsReady() {
  if (window.padelmeshMaps) return Promise.resolve(window.padelmeshMaps)

  return new Promise((resolve) => {
    document.addEventListener(
      'maps:ready',
      () => resolve(window.padelmeshMaps),
      { once: true }
    )
  })
}
